import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-article]')) return;

  addEventListeners();
  articleCheckLikeBtnState();
  articleReadingTime();
  articleLikesAndShareSticky();
}

function addEventListeners() {
  articleHandleButtonClick();
  articleShowSticky();
}

function articleShowSticky() {
  const header = $('header .n-main-header-responsive');
  const stickyHeader = $('[data-au-article-sticky]');
  const mainTitle = $('[data-au-article-header] [data-au-title]');

  function updateStickyTop() {
    const rect = header?.getBoundingClientRect();
    const headerHeight = rect?.height || 0;
    const headerTop = rect?.top || 0;
    stickyHeader.style.top = `${headerHeight + headerTop}px`;
  }

  window.addEventListener('scroll', updateStickyTop);
  // Mostrar u ocultar el sticky cuando el title desaparezca
  const observer = new IntersectionObserver(
    ([entry]) => {
      stickyHeader.style.opacity = entry.isIntersecting ? '0' : '1';
      updateStickyTop();
    },
    {
      threshold: 0,
    },
  );

  observer.observe(mainTitle);

  // If the header exists, show the sticky when it's above the title.
  if (header) {
    articleShowStickyWithHeader();
  }

  function isVisibleInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
  }

  function isCoveredWhileVisible(targetElement, coveringElement) {
    if (!isVisibleInViewport(targetElement)) {
      stickyHeader.style.opacity = '1';
    } else {
      stickyHeader.style.opacity = '0';
    }

    const targetRect = targetElement.getBoundingClientRect();
    const coveringRect = coveringElement.getBoundingClientRect();

    const isOverlapping = !(
      targetRect.bottom <= coveringRect.top ||
      targetRect.top >= coveringRect.bottom ||
      targetRect.right <= coveringRect.left ||
      targetRect.left >= coveringRect.right
    );

    return isOverlapping;
  }

  function articleShowStickyWithHeader() {
    window.addEventListener('scroll', () => {
      if (isCoveredWhileVisible(mainTitle, header)) {
        stickyHeader.style.opacity = '1';
        updateStickyTop();
      }
    });
  }

  // If the thumbnail has a video, play it on click
  const playBtn = $('[data-au-sticky-media-play]');
  if (playBtn) {
    playSticky(playBtn);
  }
}

/**
 *
 * Function to play video if sticky thumbnail has video
 */

function playSticky(playBtn) {
  playBtn.addEventListener('click', () => {
    const iframe = $('[data-au-inline-media-iframe]');
    const inlineMedia = iframe.closest('[data-au-inline-media]');

    const iframeSrc = iframe.getAttribute('src');
    const iframeSrcAutoplay = `${iframeSrc}&autoplay=1`;

    iframe.scrollIntoView({ behavior: 'smooth', block: 'center' });
    // add autoplay to iframe
    iframe.setAttribute('src', iframeSrcAutoplay);
    iframe.removeAttribute('tabindex');
    // add au-inline-media--video-visible class to show video
    inlineMedia.classList.add('au-inline-media--video-visible');

    const titleText = playBtn.closest('[data-au-article]').querySelector('[data-au-title]').innerText;
    const clickText = playBtn.querySelector(':not([data-au-icon])').innerText;
    const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;
    // datalayer
    window.dataLayer.push({
      event: 'navigation',
      content_type: 'clickVideo',
      item_id,
    });
  });
}

/**
 *
 * Function to manage sticky position of like btn on page load
 */

function articleLikesAndShareSticky() {
  const stickyDiv = $('[data-au-article-actions]');
  const footer = $('[data-au-article-footer]');

  // Listen for the scroll event
  window.addEventListener('scroll', () => {
    const scrollY = window.scrollY || window.pageYOffset;
    const footerPosition = footer.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;

    // If scroll is at the top (0), hide the sticky div
    if (scrollY === 0) {
      stickyDiv.style.opacity = 0;
      stickyDiv.style.pointerEvents = 'none';
    } else if (footerPosition <= windowHeight) {
      // If the footer is visible (near the bottom of the page), hide the sticky div
      stickyDiv.style.opacity = 0;
      stickyDiv.style.pointerEvents = 'none';
    } else {
      // Show the sticky div if scrolled down and footer is not visible
      stickyDiv.style.opacity = 1;
      stickyDiv.style.pointerEvents = 'auto';
    }
  });
}

/**
 *
 * Function to check if like btn is clicked or not
 */
function articleCheckLikeBtnState() {
  const isClicked = localStorage.getItem('articleLiked');
  const buttons = $$('[data-au-article-like]');

  // If clicked, add the 'clicked' class to all buttons
  if (isClicked === 'true') {
    articleHanldeLikeBtnState(buttons);
  }
}

/**
 *
 * Functions on like btn click
 */
function articleHandleButtonClick() {
  const buttons = $$('[data-au-article-like]');

  buttons.forEach((button) => {
    button.addEventListener('click', (e) => {
      const button = e.currentTarget;
      const titleText = button.closest('[data-au-article]').querySelector('[data-au-title]').innerText;
      const clickText = button.querySelector(':not([data-au-icon])').innerText;
      const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

      // datalayer
      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickIcono',
        item_id,
      });

      const isLiked = localStorage.getItem('articleLiked') === 'true';
      if (isLiked) {
        // remove like
        localStorage.removeItem('articleLiked');
        articleRemoveLikeBtnState(buttons);
      } else {
        // add like
        localStorage.setItem('articleLiked', 'true');
        articleHanldeLikeBtnState(buttons);
      }
    });
  });
}

/**
 *
 * @param likeBtns like buttons
 * Change icon, class to remove pointer events and change text
 */
function articleHanldeLikeBtnState(likeBtns) {
  likeBtns.forEach((btn) => {
    const spanInButton = btn.querySelector('[data-au-icon]');
    const isInFooter = btn.closest('[data-au-article-footer]');

    btn.classList.add('au-article__like-btn--liked');
    spanInButton.classList.add('icon-heart-filled');
    spanInButton.classList.remove('icon-heart');
    if (isInFooter) {
      const footerLikeText = btn
        .closest('[data-au-article-footer]')
        .querySelector('[data-au-article-footer-like-text]');

      // Save the original text if not already saved
      if (!footerLikeText.dataset.originalText) {
        footerLikeText.dataset.originalText = footerLikeText.textContent;
      }

      footerLikeText.textContent = footerLikeText.dataset.auArticleFooterLikeText;
    }
  });
}

/**
 *
 * @param likeBtns like buttons
 * Remove liked state: remove class, change icon
 */
function articleRemoveLikeBtnState(likeBtns) {
  likeBtns.forEach((btn) => {
    const spanInButton = btn.querySelector('[data-au-icon]');
    const isInFooter = btn.closest('[data-au-article-footer]');

    btn.classList.remove('au-article__like-btn--liked');
    spanInButton.classList.remove('icon-heart-filled');
    spanInButton.classList.add('icon-heart');

    if (isInFooter) {
      const footerLikeText = btn
        .closest('[data-au-article-footer]')
        .querySelector('[data-au-article-footer-like-text]');

      // Restore the original text
      if (footerLikeText.dataset.originalText) {
        footerLikeText.textContent = footerLikeText.dataset.originalText;
      }
    }
  });
}

/**
 *
 * Add reading time on article header
 */
function articleReadingTime() {
  const text = $('[data-au-article]').innerText;
  const wpm = 225;
  const words = text.trim().split(/\s+/).length;
  const time = `${Math.ceil(words / wpm)}`;
  $('[data-au-article-time]').innerText = time;
}

export default { init };
